export {
  checkCompanyUnique,
  checkPhone,
  checkPhoneUnique,
  createCompany,
  emongoliaRegisterVerify,
  emongoliaResendOtp,
  login,
  loginByFacebook,
  loginByGoogle,
  register,
  resetPassword,
  resetPasswordCode,
  verifyPhone,
} from '@/features/auth/api/auth.api';

export { getOAuthClientInfo } from '@/features/auth/api/oauth.api';

export { oauthQueryKeys, useOAuthClientInfo } from '@/features/auth/api/oauth.queries';

export { usePasswordLogin } from '@/features/auth/api/auth.queries';

export {
  loginWithCredentials,
  loginWithFacebook,
  loginWithGoogle,
  logoutSession,
  registerWithCredentials,
} from '@/features/auth/api/auth.session';
